<script setup lang="ts">
import { storeToRefs } from 'pinia';


defineOptions({
  name: 'DashboardBaseDarkModelToggel',
});

const { darkmode } = storeToRefs(useThemeStore());

const { toggleTheme } = useThemeStore();

const handleToggle = () => {
  toggleTheme(!darkmode.value);
};
</script>

<template>
  <v-btn
    variant="text"
    icon
    @click="handleToggle"
  >
    <v-icon>
      {{ darkmode ? 'mdi-brightness-7' : 'mdi-brightness-2' }}
    </v-icon>
  </v-btn>
</template>
